
import IntersectionObserverWrapper from '../utilities/intersection-observer'

const MAX_INTERSECTION_CLASS_DURATION = 2500

export default class Component {
  constructor (element) {
    this.element = element
    this.observedIntersectionElements = []
    this.intersectionObserver = null

    this.init()
    this.initIntersectionObserver()

    // We return this object to bind the instance.
    return this
  }

  static init () {
    // Override this method
  }

  initIntersectionObserver () {
    if (!this.observedIntersectionElements.length) {
      return
    }

    this.observedIntersectionElements = [...this.observedIntersectionElements] // cast to array
    this.observedIntersectionElements = this.observedIntersectionElements.filter(element => element.getBoundingClientRect().top > window.innerHeight) // Remove visible or scrolled-past elements

    this.intersectionObserver = new IntersectionObserverWrapper(this.onIntersect.bind(this), {
      root: null, rootMargin: '0px 0px 0px 0px', threshold: [0, 0.25, 0.5, 0.75, 1]
    }, false, false, false)

    this.observedIntersectionElements.forEach(element => {
      element.classList.add(`${element.classList[0]}--intersection-observed`)
      this.intersectionObserver.observe(element)
    })
  }

  onIntersect (entry) {
    if (!entry) {
      return
    }

    if (!entry.intersectionRatio) {
      return
    }

    entry.target.classList.add(`${entry.target.classList[0]}--intersected`)
    entry.target.classList.remove(`${entry.target.classList[0]}--intersection-observed`)
    window.setTimeout(() => entry.target.classList.remove(`${entry.target.classList[0]}--intersected`), MAX_INTERSECTION_CLASS_DURATION)

    this.intersectionObserver.unobserve(entry.target)
    this.observedIntersectionElements = this.observedIntersectionElements.filter(element => element !== entry.target)

    if (!this.observedIntersectionElements.length) {
      this.intersectionObserver.disconnect()
    }
  }
}
